export const MODAL_ADD_USER = 'addUser';
export const MODAL_DELETE_LIST = 'deleteList';
export const MODAL_CONFIRM_CALENDAR = 'calendarConfirm';
export const MODAL_USER_DELETE = 'userDelete';
export const MODAL_FULL_HOURS = 'fullHours';
